import React, { FC } from "react";
import { Stack } from "@mui/material";

import { Colors } from "@theme/colors";
import TextBlock from "@components/TextBlock";

type SectionContent = {
  title: string;
  body: string;
};

interface Props {
  sections: Array<SectionContent>;
}

const SectionSummary: FC<Props> = ({ sections }) => {
  return (
    <Stack
      sx={{
        maxWidth: "724px",
        marginBottom: "-16px",
        padding: "16px 24px",
        backgroundColor: Colors.BackgroundBody,
        borderRadius: { xs: "0", md: "15px" },
      }}
    >
      {sections.map((item, idx) => {
        return (
          <TextBlock
            title={item.title}
            sections={[item.body]}
            key={`para-${idx}`}
          />
        );
      })}
    </Stack>
  );
};

export default SectionSummary;
